import Washi from 'washi';
import Map from '../mixins/map';
import Hash from '../utils/hash';

var Show = Washi.$.extend(Map, {

  animate: true,
  minZoom: 1,
  maxZoom: 3,

  initialize: function () {
    this.configure();
    Hash.listen((slug) => {
      this.render().then(() => {
        this.position(slug, this.zoomLevelMax());
      });
    }, true);

    if (!Hash.val()) {
      this.render();
    }
  },

  findRouteByKey: function (key, value) {
    for (var i = 0; i < this.routes.length; i++) {
      if (this.routes[i][key] === value) {
        return this.routes[i];
      }
    }
    return false;
  },

  getMarker: function (key) {
    return this.findRouteByKey('key', key);
  },

  setMapHeight: function (height) {
    if (this.isNarrow) {
      var mapHeight = Math.min(height, this.height);
      this.el.setAttribute('style', 'height:' + mapHeight + 'px');
    }
  },

  shouldZoom: function () {
    return this.isNarrow || Hash.val();
  },

  zoomLevel: function () {
    var zoom = 1;
    if (this.shouldZoom()) {
      zoom = this.isNarrow ? this.zoomLevelNarrow() : this.minZoom;
    }
    return zoom;
  },

  zoomLevelMax: function () {
    return this.zoomRange();
  },

  zoomLevelNarrow: function () {
    var mapAspect = this.width / this.height;
    var minZoomHeight = this.el.offsetWidth / mapAspect;
    return this.el.offsetHeight / minZoomHeight;
  }

});

export default Show;
